import { InventoryLevelLedgerTableRowSchema } from "@redotech/redo-fulfillment-wms-common/schema/inventory-level";
import { VALID_PAGE_SIZES } from "@redotech/redo-model/views/views";
import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import {
  OpensearchPaginationCursorSchema,
  SortDirection,
} from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const inventoryLevelLedgerFilterNames = [
  "productSku",
  "productName",
  "storageLocationName",
  "userName",
] as const;
export type InventoryLevelLedgerFilterName =
  (typeof inventoryLevelLedgerFilterNames)[number];

export const getInventoryLevelLedger = {
  name: "getInventoryLevelLedger" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z
      .number()
      .refine((value) => VALID_PAGE_SIZES.includes(value as any), {
        message: `pageSize must be one of: ${VALID_PAGE_SIZES.join(", ")}`,
      }),
    search: z.string().nullish(),
    sort: z
      .object({ key: z.string(), direction: createEnum(SortDirection) })
      .nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    ledgerEntries: z.array(InventoryLevelLedgerTableRowSchema),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};

export const getInventoryLevelLedgerCount = {
  name: "getInventoryLevelLedgerCount" as const,
  input: z.object({
    search: z.string().nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
  }),
  output: z.object({ total: z.number() }),
};

export const getInventoryLevelLedgerUniqueValues = {
  name: "getInventoryLevelLedgerUniqueValues" as const,
  input: z.object({
    filterName: createEnum(inventoryLevelLedgerFilterNames),
    filterSearch: z.string().nullish(),
  }),
  output: z.object({ values: z.array(z.string()) }),
};
